<template>
  <sui-page>
    <sui-page-header
      :title="pageTitle"
      :location-list="pageLocations"
      :is-show="isPageHeaderShow"
      :is-favorites="isMyFavorites"
    />
    <sui-page-contents>
      <!-- Bar Chart-[S] -->
      <sui-chart-bar
        v-if="chartData !== null"
        :styles="{display: 'block'}"
        :width="800"
        :height="400"
        :chart-data="chartData"
        :options="chartOptions"
      />
      <!-- Bar Chart-[E] -->
    </sui-page-contents>
  </sui-page>
</template>

<script>

export default {
  name: 'CompHistogramChart',
  data() {
    return {
      // Bar Chart 옵션
      chartOptions: {
        // responsive: true,
        // labels: [0, 1, 2, 3, 4],
        // title: { display: true, text: 'Vertical' },
        scales: {
          xAxes: [{
            display: false,
            barPercentage: 1.3,
            ticks: {
              max: 3,
            },
          }, {
            display: true,
            ticks: {
              autoSkip: false,
              max: 4,
            },
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
            },
          }],
        },
      },
      chartData: {
        labels: [0, 1, 2, 3, 4],
        datasets: [{
          label: 'Group A',
          data: [12, 19, 3, 5],
          backgroundColor: 'rgba(255, 99, 132, 1)',
        }],
      },

      // Bar Chart 데이터
      // chartData: [null, null, null, null, null, null],

      // 페이지 헤더
      pageTitle: 'Histogram(Bar Chart) UI',
      pageLocations: ['Charts', 'Histogram(Bar)', 'Guide'],
      isPageHeaderShow: true,
      isMyFavorites: true,
    };
  },
  mounted() {
    // this.fillChartData();
  },
  methods: {
    onErrorFillChartData(error) {
      console.log('CompHistogramChart.onErrorFillChartData() was called.');
      console.log(error);
    },
    setChartOptions() {
      // [Sample] 예를 들어. 데이터 모양(서버 response 데이타)이 아래와 같다 가정.
      // data = [
      //   {
      //     label: '행복지수',
      //     data: [40, -20, 12, 39, 15, 40, -39, 80, 40, -20, 12, 11],
      //   },
      //   {
      //     label: '불쾌지수',
      //     data: [40, -20, 12, 39, 15, 40, -39, 80, 40, -20, 12, 11],
      //   },
      // ];

      // Data
      /*
      const chartOptions = {
        labels: [0, 1, 2, 3, 4],

        datasets: [{
          label: 'Number of Arrivals',
          data: [19, 28, 20, 16],
          backgroundColor: 'green',
        }],
      };
      */

      // Set
      this.$set(this.chartData, 0, _.cloneDeep(this.chartOptions));
    },
    fillChartData() {
      // [Sample] 서버로부터 차트 데이터 호출 시,
      // http
      //   .request("pageId", "dataServiceId", {})
      //   .then(this.setChartOptions)
      //   .catch(this.onErrorFillChartData);

      this.setChartOptions();

      // [Sample] 이미 있는 차트 데이터셋에, 스크립트로 데이터셋 추가할 때,
      /*
      this.chartData[0].datasets.push({
        label: '미소지수',
        backgroundColor: 'rgba(120, 3, 255, 0.8)',
        data: [70, 10, -30, 50, 20, 60, 59, 20, 20, 40, -22, 21],
      });
      */
    },
  },
};
</script>
